import { FormikHelpers } from 'formik'
import { DtoInitialValuesAddMO } from './Interfaces/DtoInitialValuesAddMO'
import { PreLiquidationProcess } from '../../Preliquidar/Application/UseCasePreLiquidationProcesses/UseCasePreLiquidationProcesses'
import { DtoTrabajosDE } from '../../Lista/Domain/DtoTrabajosDE'
import { Dispatch, SetStateAction } from 'react'
import { AdapterGenerico } from '../../../../shared/Infraestructure/AdapterGenerico'
import { ObtenerZonaAsignada, BuscarZonaContratista, ObtenerPrecioContratistaVigente, CodsMapeoMOMaterial } from 'sigo-package'
import { DtoPrecioMaterial } from '../../../../../app/Domain/DtoPrecioMaterial'
import { DtoItems } from '../../../../../app/Domain/DtoItems'
import { DtoAsignacionValorizacion } from '../../../Trabajos/Asignacion/Domain/DtoAsignacionValorizacion'
import { LanguageTranslate } from '../../../../shared/Infraestructure/LanguageTranslate'
import { PrecioEspecialidadENTITY, ValorizacionManoObraDTO } from 'sigo-entities'

const languageTranslate = LanguageTranslate()
export const onSubmitFormAddMOShared = (
  values: DtoInitialValuesAddMO,
  formikHelpers: FormikHelpers<DtoInitialValuesAddMO>,
  trabajo: DtoTrabajosDE | null,
  setTrabajo: Dispatch<SetStateAction<DtoTrabajosDE | null>>,
  PrecioEspecialidad: PrecioEspecialidadENTITY[],
  dataPrecioMaterial: DtoPrecioMaterial[],
  dataItems: DtoItems[],
): void | Promise<any> => {
  if (typeof values.manoObra !== 'string' && trabajo) {
    if (!trabajo.Ultima_asignacion.Empresa.Propia) {
      const { contratista, zona } = getContratista(PrecioEspecialidad, values.manoObra.dataComplete, trabajo)
      const contratistaAux = values.manoObra.dataComplete.DatosCatalogoMO.DatosPrecioEspecialidad.Contratistas.find(e => e.Empresa.Codigo === trabajo?.Ultima_asignacion.Empresa.Codigo)
      if (!contratistaAux && zona) {
        contratista[0].Zonas = [zona]
        values.manoObra.dataComplete.DatosCatalogoMO.DatosPrecioEspecialidad.Contratistas = contratista
      } else if (contratistaAux) {
        const ZonaAsignada = ObtenerZonaAsignada(trabajo.ColeccionObras[0])
        const SearchZona = BuscarZonaContratista(contratistaAux, trabajo.ColeccionObras[0], ZonaAsignada)
        if (!SearchZona && zona) contratistaAux?.Zonas.push(zona)
      }
    }
    const newDtoAsignacionValorizacion = PreLiquidationProcess.generarDtoAsignacionValorizacion(values.manoObra.dataComplete, values.cantidad)
    const newItem = addItemReservaMaterial(trabajo, newDtoAsignacionValorizacion, dataPrecioMaterial, dataItems, values.cantidad)
    const trabajoUpdate = structuredClone(trabajo)
    trabajoUpdate?.Ultima_asignacion.Valorizaciones.push(newDtoAsignacionValorizacion)
    values.manoObra.dataComplete.Cantidad = values.cantidad
    trabajoUpdate?.ColeccionManoObra[0].Valorizacion.push(values.manoObra.dataComplete)
    if (newItem) trabajoUpdate?.ColeccionReserva[0].Item.push(newItem)   
    setTrabajo(trabajoUpdate)
    formikHelpers.resetForm()
    AdapterGenerico.createMessage(languageTranslate.general.Agregado, languageTranslate.general.Se_agrego_asignación, 'success')
  }
}

const addItemReservaMaterial = (
  trabajo: DtoTrabajosDE | null,
  newAsignacion: DtoAsignacionValorizacion,
  dataPrecioMaterial: DtoPrecioMaterial[],
  dataItems: DtoItems[],
  cantidad: number
) => {
  const codMO = CodsMapeoMOMaterial.find(e => e.CodigoMO === newAsignacion.ManoObra.Codigo)
  if (!codMO) return
  const precioMaterial = dataPrecioMaterial.filter(e =>
    e.Item.Codigo === codMO.CodigoMaterial &&
    e.Contrato.Codigo === trabajo?.ColeccionObras[0].ContratoOT.Codigo
  )
  if (precioMaterial.length !== 1) throw Error(languageTranslate.general.No_se_pudo_obtener_Precio_Material_Intente_refrescar_PrecioMaterial)
  const item = dataItems.filter(e => e.Codigo === codMO.CodigoMaterial)
  if (item.length !== 1) throw Error(languageTranslate.general.No_se_pudo_obtener_Item_Intente_refrescar_Items)
  return PreLiquidationProcess.generarDtoItem(item[0], precioMaterial[0], cantidad)
}

const getContratista = (PrecioEspecialidad: PrecioEspecialidadENTITY[], dataComplete: ValorizacionManoObraDTO, trabajo: DtoTrabajosDE | null) => {
  if (!trabajo) throw Error(languageTranslate.general.No_hay_trabajo)
  const precios = PrecioEspecialidad.filter(e => e.Especialidad.Codigo === dataComplete.DetalleChile.Especialidad.Codigo)
  const msgErrEspecialidad = `${languageTranslate.general.Especialidad_con_Codigo} "${dataComplete.DetalleChile.Especialidad.Codigo}"`
  if (!precios.length) throw Error(`¡${msgErrEspecialidad} ${languageTranslate.general.no_existe_en_Catalogo_Precio_Especialidad}`)

  const precio = precios.filter(e => e.ContratoOT.Codigo === trabajo.ColeccionObras[0].ContratoOT.Codigo)
  const msgErrContrato = `${msgErrEspecialidad}, ${languageTranslate.general.con_codigo_de_contrato} "${trabajo.ColeccionObras[0].ContratoOT.Codigo}"`
  if (!precio.length) throw Error(`¡${msgErrContrato} ${languageTranslate.general.no_existe_en_Catalogo_Precio_Especialidad}`)
  if (precio.length > 1) throw Error(`¡${msgErrContrato} ${languageTranslate.general.existe} ${precio.length} ${languageTranslate.general.registros_en_Catalogo_Precio_Especialidad}`)

  const contratista = precio[0].Contratistas.filter(e => e.Empresa.Codigo === trabajo.Ultima_asignacion.Empresa.Codigo && e.Estado.ID_Estado === 1)
  const msgErrEmpresa = `${msgErrContrato}, ${languageTranslate.general.con_codigo_de_Empresa} "${trabajo.Ultima_asignacion.Empresa.Codigo}"`
  if (!contratista.length) throw Error(`¡${msgErrEmpresa} ${languageTranslate.general.no_existe_en_Catalogo_Precio_Especialidad}`)
  if (contratista.length > 1) throw Error(`¡${msgErrEmpresa} ${languageTranslate.general.existe} ${contratista.length} ${languageTranslate.general.registros_en_Catalogo_Precio_Especialidad}`)

  const ZonaAsignada = ObtenerZonaAsignada(trabajo.ColeccionObras[0])
  const SearchZona = BuscarZonaContratista(contratista[0], trabajo.ColeccionObras[0], ZonaAsignada)

  const msgErrZona = `${msgErrEmpresa}, ${languageTranslate.general.con_zona} "${ZonaAsignada}"`
  if (!SearchZona) throw Error(`${msgErrZona} ${languageTranslate.general.no_existe_en_Catalogo_Precio_Especialidad}`)

  const zona = contratista[0].Zonas.find(e => e.Codigo === SearchZona.Codigo)
  const actividad = zona?.Actividades.filter(e => e.Codigo === dataComplete.DetalleChile.Actividad.Codigo && e.Estado.ID_Estado === 1)
  const msgErrActividad = `${msgErrZona}, ${languageTranslate.general.con_codigo_de_actividad} "${dataComplete.DetalleChile.Actividad.Codigo}"`
  if (!actividad?.length) throw Error(`¡${msgErrActividad} ${languageTranslate.general.no_existe_en_Catalogo_Precio_Especialidad}`)
  if (actividad?.length > 1) throw Error(`¡${msgErrActividad}  ${languageTranslate.general.existe} ${actividad.length} ${languageTranslate.general.registros_en_Catalogo_Precio_Especialidad}`)

  const Precio = ObtenerPrecioContratistaVigente({ actividad: actividad[0], FechaVerificar: new Date() })

  if (!Precio) throw Error(`${languageTranslate.general.No_se_encontro_Precio_Vigente_en_la_Linea} <span style="color: red">${dataComplete.DetalleChile.Linea}</span>, para ${msgErrActividad}!`)
  return { contratista, zona }

}